import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { 
  NotificationListResponse, 
  NotificationDetailResponse,
  NotificationDeleteRequest, 
  NotificationDeleteResponse,
  NotificationUnreadCountResponse,
  NotificationMarkReadResponse
} from '../interfaces';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private http = inject(HttpClient);

  getNotifications(page = 1, limit = 20, category: string): Observable<NotificationListResponse> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('limit', limit.toString())
      .set('category', category);
    return this.http.get<NotificationListResponse>(`${environment.baseurl.api}/v7/notifications`, { params });
  }

  getNotificationById(id: string): Observable<NotificationDetailResponse> {
    return this.http.get<NotificationDetailResponse>(`${environment.baseurl.api}/v7/notifications/${id}`);
  }

  deleteNotifications(ids: string[]): Observable<NotificationDeleteResponse> {
    const body: NotificationDeleteRequest = { ids };
    return this.http.delete<NotificationDeleteResponse>(`${environment.baseurl.api}/v7/notifications`, { body });
  }

  getUnreadCount(): Observable<NotificationUnreadCountResponse> {
    return this.http.get<NotificationUnreadCountResponse>(`${environment.baseurl.api}/v7/notifications/unread-count`);
  }

  markAllAsRead(): Observable<NotificationMarkReadResponse> {
    return this.http.put<NotificationMarkReadResponse>(`${environment.baseurl.api}/v7/notifications/read-all`, {});
  }

  markAsRead(id: string): Observable<NotificationDetailResponse> {
    return this.http.put<NotificationDetailResponse>(`${environment.baseurl.api}/v7/notifications/${id}/read`, {});
  }
}